const CircleLockIcon = () => (
  <svg
    viewBox='0 0 98 98'
    role='img'
    aria-label='Circle Lock Icon'
    xmlns='http://www.w3.org/2000/svg'>
    <g transform='translate(0,98) scale(0.1,-0.1)' fill='currentColor' stroke='none'>
      <path d='M370 964 c-398 -106 -501 -617 -173 -865 273 -207 677 -68 764 263 96 364 -232 697 -591 602z m225 -59 c211 -55 354 -270 318 -479 -66 -388 -566 -496 -782 -169 -213 321 91 744 464 648z' />
      <path d='M435 751 c-43 -19 -68 -59 -73 -115 -3 -43 -8 -55 -23 -59 -18 -5 -19 -15 -17 -159 l3 -153 165 0 165 0 3 158 c2 149 1 157 -17 157 -15 0 -19 9 -23 56 -8 93 -100 151 -183 115z m114 -65 c13 -13 25 -42 28 -65 l6 -41 -93 0 -93 0 6 41 c7 55 40 89 87 89 26 0 43 -7 59 -24z' />
    </g>
  </svg>
)

export default CircleLockIcon